import React from "react";
import "./joinushomepage.css";

export default function MembershipHero() {
  return (
    <div
      className="membership-hero"
      style={{ backgroundImage: "url('/assets/joinusbanner.png')" }}
    >
      <div className="hero-content">
        <h2 className="hero-title">
          Join our <em>membership</em> for <br />
          daily bits of <em>astrology</em>
        </h2>
        <p className="hero-sub">
          We provide the essentials for your astrology needs.
        </p>
        <button className="btn-join">Comming Soon</button>
      </div>
    </div>
  );
}

